export default {
  // 银行收款流水查询(erp调用)
  EAS_TRANSACTION_QUERY: '/financial/fundCollectionEas/easTransactionQuery',
  // 关联业务与银行账户根据公司名称获取
  GET_CONFIG_BY_COMPANY_NAME: '/financial/fundCollectionEas/getConfigByCompanyName',
  // 关联业务与银行账户-保存配置
  SAVE_CONFIG: '/financial/fundCollectionEas/saveConfig',
};
